import { ChangeDetectionStrategy, Component } from '@angular/core';
import { APP_VERSION, YEAR_DATE_FORMAT } from '../../../common/constants';
import { format } from 'date-fns';

@Component({
    selector: 'public-tracking-footer',
    templateUrl: './public-tracking-footer.component.html',
    styleUrls: ['./public-tracking-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PublicTrackingFooterComponent {
  logo = 'InTrack 2.0';
  appVersion = APP_VERSION;
  currentYear: string = format(new Date(), YEAR_DATE_FORMAT);
  footerConfig: Array<{ translationKey: string; link: string }> = [
    {
      translationKey: 'footer.legalDocuments.imprint.title',
      link: '/legal-documents/imprint',
    },
    {
      translationKey: 'footer.legalDocuments.legalNotice.title',
      link: '/legal-documents/legal-notice',
    },
    {
      translationKey: 'footer.dependencyLicenses.title',
      link: '/dependency-licenses',
    },
    {
      translationKey: 'footer.dataProtectionNotice.title',
      link: '/data-protection-notice/default',
    },
  ];
}
